import { ChakraProvider } from '@chakra-ui/react';
import ProtectedRoute from 'components/routing/ProtectedRoute';
import { NAVIGATE } from 'constant/navigation';
import { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import SessionTimeout from 'utils/SessionTimeout';
import './assets/css/App.css';
import AdminLayout from './layouts/admin';
import AuthLayout from './layouts/auth';
import ClientLayout from './layouts/client';
import initialTheme from './theme/theme';

export default function Main() {
	const [currentTheme, setCurrentTheme] = useState(initialTheme);
	const location = useLocation();
	const showSessionTimeout = location.pathname.includes('client');

	return (
		<ChakraProvider theme={currentTheme}>
			{showSessionTimeout && (
				<SessionTimeout
					timeoutDuration={process.env.REACT_APP_SESSION_TIMEOUT_MILLISECONDS}
				/>
			)}

			<Routes>
				<Route
					path='auth/*'
					element={
						<GoogleReCaptchaProvider
							reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
							scriptProps={{ async: true, defer: true }}
						>
							<AuthLayout />
						</GoogleReCaptchaProvider>
					}
				/>
				<Route
					path='admin/*'
					element={
						<ProtectedRoute>
							<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
						</ProtectedRoute>
					}
				/>
				<Route
					path='client/*'
					element={
						<ProtectedRoute>
							<ClientLayout theme={currentTheme} setTheme={setCurrentTheme} />
						</ProtectedRoute>
					}
				/>
				<Route path='/*' element={<AuthLayout />} />
				<Route path='/' element={<Navigate to={NAVIGATE.SIGN_IN} replace />} />
			</Routes>
		</ChakraProvider>
	);
}
